import { ColorSchemeName } from '@/config/themeConfig';
import { getEnvironment } from '@/helpers/getEnvironment';
import client from './client';

export interface ThemeSettings {
  colorScheme: ColorSchemeName;
  environment: string;
}

async function get() {
  const environment = getEnvironment();
  const { data } = await client.get<ThemeSettings>(`/theme`, {
    params: { environment },
  });
  return data;
}

async function update(colorScheme: ColorSchemeName) {
  const environment = getEnvironment();
  const { data } = await client.patch<ThemeSettings>(`/theme`, {
    colorScheme,
    environment,
  });
  return data;
}

export const theme = {
  get,
  update,
};
